import { Typography } from '@mui/material';
import { format, parseISO } from 'date-fns';
import { enUS } from 'date-fns/locale';
import { useFormBuilder } from '../../Context/FormBuilderContext';

export function FormHeader() {
  const { state } = useFormBuilder();

  function formatIsoToCustom(isoString: string) {
    const date = parseISO(isoString);
    const formatted = format(date, 'hh:mm a MM/dd/yyyy', { locale: enUS });

    return formatted;
  }

  return (
    <div
      style={{
        background: '#EAECF0',
        width: '100%',
        padding: '14px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <div style={{ flex: 1 }}></div>

      <Typography
        variant="h6"
        style={{
          flex: 1,
          textAlign: 'center',
          fontSize: '14px',
          color: '#3650DE',
          fontWeight: '400',
        }}
      >
        {state.form.name}
      </Typography>

      <Typography
        variant="h6"
        style={{
          flex: 1,
          textAlign: 'right',
          fontSize: '12px',
          color: '#98A2B3',
          marginRight: '30px',
        }}
      >
        Last saved on: {formatIsoToCustom(state.form.updatedAt)}
      </Typography>
    </div>
  );
}
